import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { OEmbedRichResponseModel } from './models/oembed-rich-response.model';
import { HttpVerbsEnum } from '../shared/enums/http-verbs.enum';
import { NeptuneApi } from '../genericApi/neptune.api';

@Injectable()
export class OEmbedApi {
    constructor(
        private neptuneApi: NeptuneApi,
    ) { }

    /**
     * Gets the oembed information for a twitter post
     * @param url A Twitter post URL
     */
    twitter(url: string): Observable<OEmbedRichResponseModel> {
        const requestPath = `/twitter/oembed?url=${encodeURIComponent(url)}`;

        return this.neptuneApi.api<OEmbedRichResponseModel>(
            requestPath,
            null,
            HttpVerbsEnum.GET
        );
    }

    /**
     * Gets the oembed information for an instagram post
     * @param url An Instagram post URL
     */
    instagram(url: string): Observable<OEmbedRichResponseModel> {
        const requestPath = `/instagram/oembed/?url=${encodeURIComponent(url)}`;

        return this.neptuneApi.api<OEmbedRichResponseModel>(
            requestPath,
            null,
            HttpVerbsEnum.GET
        );
    }

    /**
     * Gets the oembed information for a Bluesky post
     * @parma url a Bluesky post URL
     */
    bluesky(url: string): Observable<OEmbedRichResponseModel> {
        const requestPath = `/bluesky/oembed?url=${encodeURIComponent(url)}`;

        return this.neptuneApi.api<OEmbedRichResponseModel>(
            requestPath,
            null,
            HttpVerbsEnum.GET
        );
    }

    // @TODO NEP-32721 - facebook doesn't work right now because of a CORS problem
    //       we will need to proxy it like we do for twitter
    // facebook(url: string): Observable<OEmbedRichResponseModel> {
    //     const requestPath = `/plugins/post/oembed.json?href=${encodeURIComponent(url)}`;

    //     this.serviceApi.apiUrl = 'https://www.facebook.com';

    //     return this.serviceApi.api<OEmbedRichResponseModel>(
    //         requestPath,
    //         null,
    //         HttpVerbsEnum.GET
    //     );
    // }
}
